<template>
  <main class="view objects">
    <div v-if="computedFilters" class="filters">
      <Pill
        v-for="(filter, idx) in computedFilters"
        :key="`filter-${idx}`"
        :label="filter.label"
        :value="filter.value"
        :checked.sync="selectedFilters"
      />
    </div>
    <div class="grid" :style="computedColumnGap">
      <div class="column" v-for="(column, cdx) in columnData" :key="`column-${cdx}`" :style="columnCss">
          <TeaserObject
            v-for="(item, idx) in column"
            :key="`column-item-${idx}`"
            :item="item"
            :stagger="cdx + idx + 1"
            :inline-styles="columnItemCss"
          />
      </div>
    </div>
  </main>
</template>

<script>
  import TeaserObject from '@/components/ui/TeaserObject';
  import Pill from '@/components/inputs/Pill';

  export default {
    name: 'Objects',
    components: {
      Pill,
      TeaserObject,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        columnGap: 30,
        minColumnHeight: 0,

        items: [],

        selectedFilters: [],
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      numColumns() {
        const width = this.$b.clientWidth;
        if (width <= 767) { return 1; }
        if (width < 1024) { return 2; }
        return 3;
      },
      columnCss() {
        const numColumns = this.numColumns;
        const percentage = 100 / numColumns;
        const gapCount = numColumns - 1;
        const calculatedGap = (this.columnGap * gapCount) * (percentage / 100);
        return `width: calc(${percentage}% - ${calculatedGap}px);`;
      },
      columnItemCss() {
        return `margin-bottom: ${this.columnGap}px; min-height: ${this.minColumnHeight}px`;
      },
      computedColumnGap() {
        return `gap: ${this.columnGap}px;`;
      },
      computedFilters() {
        const tags = this.$b.data?.categories.objecttags;
        if (tags) {
          return tags.map(t => ({ value: t.slug, label: t.name }));
        }
        return [];
      },
      columnData() {
        const columns = [];
        const numColumns = this.numColumns;
        for (let i = 0; i < numColumns; i += 1) {
          columns.push([]);
        }

        const filters = this.selectedFilters;
        let items = this.items;
        items.sort((a, b) => a.id - b.id);
        items = items.filter(i => i.published === true).reverse();

        if (filters.length > 0) {
          items = items.filter(item => !!filters.find(f => (item.tags || []).includes(f)));
        }

        let columnIndex = 0;
        items.forEach((item) => {
          columns[columnIndex].push(item);
          columnIndex += 1;
          if (columnIndex >= numColumns) {
            columnIndex = 0;
          }
        });
        return columns;
      },
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    mounted() {
      this.items = this.$b.data.entries;
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    },
    // beforeUpdate() {},
    // updated() {},
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      handleResize() {
        const column = this.$el.querySelector('.column');
        if (column) {
          // noinspection JSSuspiciousNameCombination
          // this.minColumnHeight = column.clientWidth;
        }
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.view.objects {
  & > div.grid {
    @include max-width-constraints;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    & > .column {
      font-size: 0;
    }
  }

  & > div.filters {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    max-width: 80%;
    margin: 20px auto 40px auto;
    padding: 0 25px;
    background: white;

    @include screen-mobile {
      max-width: 100%;
    }
  }
}
</style>
